export enum E_APP_ROUTES {
  LOGIN = '/login',
  LOADING = '/loading/:id',
  REPORT = '/report/:id',
  NOT_FOUND = '*',
}
